import { AdOrderItemStatus } from '../enum';

export const adOrderItemStatusNameConstant: { [key in AdOrderItemStatus]: string } = {
  [AdOrderItemStatus.DRAFT_OWNER]: 'Черновик',
  [AdOrderItemStatus.AWAITING_PLACEMENT]: 'Ожидает размещения',
  [AdOrderItemStatus.AWAITING_SETTINGS_DATE_PLACEMENT]: 'Ожидает установки даты размещения рекламодателем',
  [AdOrderItemStatus.AWAITING_CONFIRMATION]: 'Ожидает подтверждения',
  [AdOrderItemStatus.DECLINED]: 'Отклонено',
  [AdOrderItemStatus.PUBLISHING]: 'Публикуется',
  [AdOrderItemStatus.PUBLISHED]: 'Опубликовано',
  [AdOrderItemStatus.COMPLETE]: 'Завершено',
  [AdOrderItemStatus.FAILED]: 'Ошибка',
};
